export const entityQueryKeys = {
    recent: (agentId: number) => ["entity", "recent", agentId],
    pageAll: (agentId: number) => ["page-entities", agentId],
    read: (agentId: number, entityId: string) => ["entity", "agent", agentId, "entity", entityId]
} as const;
